"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MarkAllAsRead = exports.LoadingSpinner = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var NotificationsSelectors = _interopRequireWildcard(require("../../store/reducers/NotificationReducer"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/ViewAllNotificationsTab"));

var _SettingsService = _interopRequireDefault(require("../../service/SettingsService"));

var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var NotificationsActions = _interopRequireWildcard(require("../../store/actions/actions"));

var _Wait = _interopRequireDefault(require("@react/react-spectrum/Wait"));

var _BulkNotificationUpdateService = _interopRequireDefault(require("../../service/BulkNotificationUpdateService"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _PulseNotificationMessageWrapper = _interopRequireDefault(require("../message/PulseNotificationMessageWrapper"));

var _IllustratedMessage = _interopRequireDefault(require("@react/react-spectrum/IllustratedMessage"));

require("./ViewAllNotificationsTabsContent.scss");

var _metrics = _interopRequireDefault(require("../../custom-hooks/metrics"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * TODO: Need to keep spinner in separate file.
 * This component will display the spinner.
 *
 * @class
 */
var LoadingSpinner = function LoadingSpinner(props) {
  return _react.default.createElement("div", props, _react.default.createElement(_Wait.default, {
    centered: true
  }));
};
/**
 * This component will render Mark As read section header.
 *
 * @class
 */


exports.LoadingSpinner = LoadingSpinner;

var MarkAsReadSectionHeader = function MarkAsReadSectionHeader(props) {
  var unreadCount = props.unreadCount,
      dispatchToMarkAllAsRead = props.dispatchToMarkAllAsRead;
  return _react.default.createElement("div", {
    className: "view-all-notification-list-section-header view-all-list-section-header view-all-notification-earlier-section-header"
  }, _react.default.createElement(MarkAllAsRead, {
    dispatchToMarkAllAsRead: dispatchToMarkAllAsRead,
    unreadCount: unreadCount
  }));
};

/**
 * This component will render the mark all as read button.
 *
 * @class
 */
var MarkAllAsRead = function MarkAllAsRead(props) {
  var unreadCount = props.unreadCount,
      dispatchToMarkAllAsRead = props.dispatchToMarkAllAsRead;
  return _react.default.createElement(_Button.default, {
    className: "mark-all-asread-btn",
    disabled: unreadCount === 0,
    onClick:
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      var result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _BulkNotificationUpdateService.default.markAllAsRead();

            case 2:
              result = _context.sent;

              if (result) {
                dispatchToMarkAllAsRead();
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })),
    quiet: true,
    variant: "primary"
  }, _react.default.createElement("span", {
    className: "view-all-mark-as-read-button"
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "Mark all as read",
    description: "Mark all as read",
    messageId: "MarkAllAsRead"
  })));
};
/**
 * This component is a forwardref of New Section Header
 */
// eslint-disable-next-line react/display-name


exports.MarkAllAsRead = MarkAllAsRead;
var NewSectionHeader = (0, _react.forwardRef)(function (props, ref) {
  var maxDigits = 1,
      TEN = 10,
      maxValue = Math.pow(TEN, maxDigits) - 1;
  var unreadCount = props.unreadCount,
      newFilteredNotifications = props.newFilteredNotifications,
      dispatchToMarkAllAsRead = props.dispatchToMarkAllAsRead;
  var length = newFilteredNotifications.length,
      newCount = length > maxValue ? "".concat(maxValue, "+") : "".concat(length);
  return _react.default.createElement("div", {
    className: "view-all-notification-list-section-header view-all-list-section-header view-all-notification-earlier-section-header view-all-new-notifications",
    ref: ref
  }, _react.default.createElement("strong", null, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: props.sectionHeader,
    description: "".concat(props.sectionHeader, " Header"),
    messageId: props.sectionHeader
  }), props.sectionHeader !== 'EARLIER' && length > 0 && " (".concat(newCount, ")")), _react.default.createElement(MarkAllAsRead, {
    dispatchToMarkAllAsRead: dispatchToMarkAllAsRead,
    unreadCount: unreadCount
  }));
});
NewSectionHeader.defaultProps = {
  newFilteredNotifications: []
};
/**
 * This component is a forwardRef of the Earlier section header.
 */
// eslint-disable-next-line react/display-name

var EarlierSectionHeader = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement("div", {
    className: "view-all-notification-earlier-section-header view-all-earlier-head view-all-list-section-header",
    ref: ref
  }, _react.default.createElement("strong", null, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "EARLIER",
    description: "Earlier Header",
    messageId: "Earlier"
  })));
});
/**
 * This component will display the list of notification messages.
 *
 * @param props
 * @class
 */

var NotificationsSection = function NotificationsSection(props) {
  var locale = props.locale,
      notifications = props.notifications;
  return _react.default.createElement("ul", {
    className: "view-all-notification-list-style"
  }, notifications.map(function (entry) {
    return _react.default.createElement("li", {
      key: entry.id
    }, _react.default.createElement("div", {
      className: "view-all-notification-message-container"
    }, _react.default.createElement(_PulseNotificationMessageWrapper.default, {
      clientTimeStamp: props.clientTimeStamp,
      isFloatingAlert: false,
      isReminder: false,
      locale: locale,
      pulseMessageObject: entry,
      renderCrossButton: false,
      serverTimeStamp: props.serverTimeStamp
    })));
  }));
};

NotificationsSection.defaultProps = {
  notifications: []
};
/**
 * The component will be rendered when there's no notification
 * in the applied filter.
 *
 * @class
 */

var NoResultComponent = function NoResultComponent() {
  var noResultsImg = _react.default.createElement("svg", {
    height: "103",
    viewBox: "0 0 150 103",
    width: "150"
  }, _react.default.createElement("path", {
    d: "M133.7,8.5h-118c-1.9,0-3.5,1.6-3.5,3.5v27c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V23.5h119V92c0,0.3-0.2,0.5-0.5,0.5h-118c-0.3,0-0.5-0.2-0.5-0.5V69c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v23c0,1.9,1.6,3.5,3.5,3.5h118c1.9,0,3.5-1.6,3.5-3.5V12C137.2,10.1,135.6,8.5,133.7,8.5z M15.2,21.5V12c0-0.3,0.2-0.5,0.5-0.5h118c0.3,0,0.5,0.2,0.5,0.5v9.5H15.2z M32.6,16.5c0,0.6-0.4,1-1,1h-10c-0.6,0-1-0.4-1-1s0.4-1,1-1h10C32.2,15.5,32.6,15.9,32.6,16.5z M13.6,56.1l-8.6,8.5C4.8,65,4.4,65.1,4,65.1c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l8.6-8.5l-8.6-8.5c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l8.6,8.5l8.6-8.5c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1L15.8,54l8.6,8.5c0.6,0.6,0.6,1.5,0,2.1c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.1-1.1-0.4L13.6,56.1z"
  }));

  return _react.default.createElement(_IllustratedMessage.default, {
    description: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
      defaultMessage: "You will receive important information about our products, your collaboration with fellow users, and other relevant updates",
      description: "No Notifications",
      messageId: "noNotifications"
    }),
    heading: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
      defaultMessage: "Your Notifications will appear here",
      description: "No Notifications title",
      messageId: "noNotificationsTitle"
    }),
    illustration: noResultsImg
  });
};
/**
 * This component will render all the notifications related components
 * including headers, no result section, mark as read section and notification list.
 *
 * @param props
 * @class
 */


var NotificationComponents = function NotificationComponents(props) {
  var filteredNotifications = props.filteredNotifications,
      unreadCount = props.unreadCount,
      locale = props.locale,
      filteredNotificationsById = props.filteredNotificationsById,
      newFilteredNotifications = props.newFilteredNotifications,
      earlierFilteredNotifications = props.earlierFilteredNotifications,
      searchQuery = props.searchQuery,
      filteredNotificationOffset = props.filteredNotificationOffset,
      dispatchToFetchFilteredNotifications = props.dispatchToFetchFilteredNotifications,
      dispatchToMarkAllAsRead = props.dispatchToMarkAllAsRead;
  var newNotifications = newFilteredNotifications.map(function (notif) {
    return filteredNotificationsById[notif];
  });
  var earlierNotifications = earlierFilteredNotifications.map(function (notif) {
    return filteredNotificationsById[notif];
  });
  var earlierSection = (0, _react.useRef)(null);
  var newSection = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loadMore = _useState2[0],
      setLoadMore = _useState2[1];

  var _useState3 = (0, _react.useState)('NEW'),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      sectionHeader = _useState4[0],
      setSectionHeader = _useState4[1];
  /**
   * Will attach/remove window onscroll event
   * on component mounting/unmounting.
   */


  (0, _react.useEffect)(function () {
    props.metrics.event('viewall.notifications.renderAll', {
      region: window.config && window.config.region
    });
  }, []);
  /**
   * The function will change the header based on window scroll
   * it will either be New/Earlier
   * Also, will load more notifications if the user scrolls till bottom
   * of the page.
   *
   * @param e
   */

  var handleScroll =
  /*#__PURE__*/
  function () {
    var _ref2 = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee2(e) {
      var topOffset, earlierPosition, newPosition, bottom;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              topOffset = e.target.scrollTop;
              earlierPosition = earlierSection && earlierSection.current && earlierSection.current.offsetTop;
              newPosition = newSection && newSection.current && newSection.current.offsetTop;

              if (_PulseUtil.default.isEarlierSectionHeader(topOffset, earlierPosition, newPosition)) {
                setSectionHeader('EARLIER');
              } else {
                setSectionHeader('NEW');
              }

              bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;

              if (!((bottom === 0 || bottom < 0) && filteredNotifications.length === filteredNotificationOffset && !loadMore)) {
                _context2.next = 11;
                break;
              }

              setLoadMore(true);
              _context2.next = 9;
              return dispatchToFetchFilteredNotifications(searchQuery, filteredNotificationOffset);

            case 9:
              setLoadMore(false);
              props.metrics.event('viewAllPage.loadMoreNotifications.onScroll', {
                region: window.config && window.config.region
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleScroll(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var components = [];

  if (newFilteredNotifications.length > 0) {
    components.push(_react.default.createElement(NewSectionHeader, {
      dispatchToMarkAllAsRead: dispatchToMarkAllAsRead,
      key: 1,
      newFilteredNotifications: newFilteredNotifications,
      ref: newSection,
      sectionHeader: sectionHeader,
      unreadCount: unreadCount
    }));
    components.push(_react.default.createElement(NotificationsSection, {
      clientTimeStamp: props.clientTimeStamp,
      key: 2,
      locale: locale,
      notifications: newNotifications,
      serverTimeStamp: props.serverTimeStamp
    }));
    earlierFilteredNotifications.length > 0 && components.push(_react.default.createElement(EarlierSectionHeader, {
      key: 3,
      ref: earlierSection
    }));
  }

  if (earlierFilteredNotifications.length + newFilteredNotifications.length === 0) {
    components.push(_react.default.createElement(NoResultComponent, {
      key: 4
    }));
  } else {
    newFilteredNotifications.length < 1 && components.push(_react.default.createElement(MarkAsReadSectionHeader, {
      dispatchToMarkAllAsRead: dispatchToMarkAllAsRead,
      key: 5,
      unreadCount: unreadCount
    }));
    earlierFilteredNotifications.length > 0 && components.push(_react.default.createElement(NotificationsSection, {
      clientTimeStamp: props.clientTimeStamp,
      key: 6,
      locale: locale,
      notifications: earlierNotifications,
      serverTimeStamp: props.serverTimeStamp
    }));
  }

  if (loadMore) {
    components.push(_react.default.createElement("li", {
      className: "viewall-notifications-tab-load-more-area",
      key: 10
    }, _react.default.createElement(_Wait.default, null)));
  }

  return _react.default.createElement("div", {
    className: "view-all-notification-tab-container",
    onScroll: handleScroll
  }, _react.default.createElement("div", {
    className: "view-all-notification-tab-list-container"
  }, components));
};
/**
 * Then component will render  Notifications components when API response has been recieved
 * otherwise will show spinner.
 *
 * @param props
 * @class
 */


var NotificationsPane = function NotificationsPane(props) {
  var filteredNotifications = props.filteredNotifications;

  if (!filteredNotifications) {
    return _react.default.createElement(LoadingSpinner, {
      className: "pulse-notification-tab-vertical-center"
    });
  }

  return _react.default.createElement(NotificationComponents, props);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    serverTimeStamp: (0, NotificationsSelectors.getServerTimestamp)(state),
    clientTimeStamp: (0, NotificationsSelectors.getClientTimestamp)(state),
    filteredNotifications: NotificationsSelectors.getFilteredNotifications(state),
    newFilteredNotifications: NotificationsSelectors.getFilteredNewNotifications(state),
    earlierFilteredNotifications: NotificationsSelectors.getFilteredEarlierNotifications(state),
    searchQuery: NotificationsSelectors.getSearchQueryForNotificationFilters(state),
    filteredNotificationOffset: NotificationsSelectors.getFilteredNotificationsOffset(state),
    filteredNotificationsById: NotificationsSelectors.getFilteredNotificationsById(state),
    unreadCount: NotificationsSelectors.getUnreadNotificationCount(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatchToUpdateLastNotificationsSeenTimeStamp: function dispatchToUpdateLastNotificationsSeenTimeStamp(tStamp) {
      dispatch({
        type: types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP,
        payload: tStamp
      });
    },
    dispatchToUpdateLastUserClickTimeStamp: function dispatchToUpdateLastUserClickTimeStamp(tStamp) {
      dispatch({
        type: types.SET_LAST_USER_CLICK_TIMESTAMP,
        payload: tStamp
      });
    },
    dispatchToFetchFilteredNotifications: function () {
      var _dispatchToFetchFilteredNotifications = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(searchQuery, filteredNotificationOffset) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatch(NotificationsActions.fetchPaginatedFilteredNotifications(searchQuery, filteredNotificationOffset));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function dispatchToFetchFilteredNotifications(_x2, _x3) {
        return _dispatchToFetchFilteredNotifications.apply(this, arguments);
      }

      return dispatchToFetchFilteredNotifications;
    }(),
    dispatchToMarkAllAsRead: function dispatchToMarkAllAsRead() {
      dispatch({
        type: types.MARK_ALL_NOTIFICATION_AS_READ
      });
    }
  };
};

var ViewAllNotificationsTab = function ViewAllNotificationsTab(props) {
  var locale = props.locale,
      dispatchToUpdateLastNotificationsSeenTimeStamp = props.dispatchToUpdateLastNotificationsSeenTimeStamp,
      dispatchToUpdateLastUserClickTimeStamp = props.dispatchToUpdateLastUserClickTimeStamp,
      serverTimeStamp = props.serverTimeStamp,
      clientTimeStamp = props.clientTimeStamp;
  var metrics = (0, _metrics.default)('exc.pulse.components.viewall.ViewAllNotificationsTab');
  /**
   * Send the metrics event on component render
   */

  (0, _react.useEffect)(function () {
    metrics.event('viewall.notificationsTabClicked', {
      region: window.config && window.config.region
    });
  }, []);
  /**
   * Update latest timestamp for which notifications
   * has been processed.
   */

  (0, _react.useEffect)(function () {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    updateTimeStamp();
    return (
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4() {
        var timeNow;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                timeNow = _PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
                dispatchToUpdateLastUserClickTimeStamp(timeNow);
                dispatchToUpdateLastNotificationsSeenTimeStamp(timeNow);
                _context4.next = 5;
                return _SettingsService.default.updateUserSettings({
                  lastClickTimestamp: timeNow,
                  lastNotificationSeenTimestamp: timeNow
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))
    );
  }, []);

  var updateTimeStamp =
  /*#__PURE__*/
  function () {
    var _ref4 = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee5() {
      var timeStamp,
          userSettings,
          tStamp,
          _args5 = arguments;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              timeStamp = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : null;
              _context5.next = 3;
              return _SettingsService.default.getUserSettings();

            case 3:
              userSettings = _context5.sent;
              tStamp = userSettings && userSettings.lastClickTimestamp && !timeStamp ? userSettings.lastClickTimestamp : timeStamp;
              dispatchToUpdateLastNotificationsSeenTimeStamp(tStamp);

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function updateTimeStamp() {
      return _ref4.apply(this, arguments);
    };
  }();

  return _react.default.createElement(_adobeIntlReact.default, {
    locale: locale,
    localeData: localizationStrings
  }, _react.default.createElement(NotificationsPane, (0, _extends2.default)({
    metrics: metrics
  }, props)));
};

ViewAllNotificationsTab.defaultProps = {
  locale: 'en-US',
  localizationStrings: {
    markAsUnread: 'Mark as unread',
    markAsRead: 'Mark as read',
    High: 'High',
    Approve: 'Approve',
    Reject: 'Reject',
    DismissReminder: 'Dismiss reminder',
    DismissAlert: 'Dismiss',
    Snooze: 'Remind me',
    DeleteReminder: 'Delete reminder',
    EditReminder: 'Edit reminder',
    RemindMeTomorrow: 'Remind me tomorrow',
    RemindMe60Min: 'Remind me in an hour',
    RemindMe15Min: 'Remind me in 15 minutes',
    RemindMe5Min: 'Remind me in 5 minutes'
  }
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ViewAllNotificationsTab);

exports.default = _default;